import Vue from 'vue';
import { jumpOneLinkForCommon } from '@/utils/jump-link';
import { isInApp } from '@/utils/yoda'; // 端外打开，需要跳转到端内

Vue.directive('outside-jump', {
  bind: function bind(el) {
    if (!isInApp) {
      el.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        jumpOneLinkForCommon(window.location.href);
      }, {
        capture: true
      });
    }
  }
});